import React from 'react';
import { FieldSelectDB } from 'motion-components';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';
import { FsProps } from 'motion-components';

const gqlGetValues = gql`
  query getValues($where: String, $offset: Int, $limit: Int, $order: String) {
    getRbGeographicalAreas(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id: id
        description: municipalityOrNomos
      }
      recordCount
    }
  }
`;

export function useGetRbGeoAreaAsOptionsQuery() {
  return useLazyQuery(gqlGetValues, {
    fetchPolicy: 'cache-first',
  });
}

interface LcFsProps extends FsProps {
  size?: 'sm' | 'lg';
}

export const FieldSelectRbGeoArea = ({
  label = 'Δήμος/Νομός',
  name = 'rbGeoAreaId',
  defaultValues = {},
  size = 'sm',
  ...rest
}: LcFsProps) => {
  //const where = JSON.stringify({ isActive: true });
  return (
    <FieldSelectDB
      height={size === 'lg' ? 32 : '22'}
      {...rest}
      label={label}
      name={name}
      //where={where}
      hook={useGetRbGeoAreaAsOptionsQuery}
    />
  );
};

